import cloudinaryImage from '@teamnovu/vue-cloudinary-image'

export default defineNuxtPlugin((nuxtApp) =>
  nuxtApp.vueApp.use(cloudinaryImage, {
    cloudinaryBaseUrl: nuxtApp.$config.public.CLOUDINARY_BASE_URL,
  })
)
